import "../../scss/freelancing-guide-styling-components/freelance-get-started-section.style.scss";
import { useTranslation } from "react-i18next";
import { FreelancerGetStarted } from "../images/png/icons";
import { getstarteds } from "../../constant/freelancing-guide.constant";

const FreelancerGetStartedSection = () => {
  const { t } = useTranslation();

  return (
    <div className="freelancer-section-container">
      <div className="freelancer-row">
        <div className="freelancer-col content-col">
          <div className="freelancer-content-wrapper">
            <h2 className="Heading">{t("GET_STARTED_TITLE")}</h2>
            <h6 className="section-subtitle">{t("GET_STARTED_DESC")}</h6>
            <div className="steps-wrapper">
              {getstarteds.map((getstarted, idx) => (
                <div key={getstarted.number} className="step-container">
                  <div className="step-number-container">
                    <div className="step-circle">{getstarted.number}</div>
                    {idx < getstarteds.length - 1 && <div className="step-line" />}
                  </div>
                  <div className="step-text">
                    <h6 className="step-title">{t(getstarted.title)}</h6>
                    <p className="step-description">{t(getstarted.text)}</p>
                    {getstarted.listItems && (
                      <ul className="step-list">
                        {getstarted.listItems.map((item, index) => (
                          <li key={index}>{t(item)}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="freelancer-col image-col">
          <img src={FreelancerGetStarted} alt="Freelancer Illustration" className="freelancer-image" />
        </div>
      </div>
    </div>
  );
};

export default FreelancerGetStartedSection;
